import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TicketFile } from '../models/equipment-registration-ticket-file';
import { Filter } from '../models/filter';
import { TicketFilter } from '../models/filters/ticket-filter';
import { Paging } from '../models/page';
import { TicketExternalUpdateRequest } from '../models/request/ticket-external-update-request';
import { ResponseModel } from '../models/response-model';
import { TicketExternalFindResponse } from '../models/response/ticket-external-find-response';
import { Ticket } from '../models/ticket';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TicketService {


  private url = `${environment.url}/tickets`;
  private urlWithFiles = `${environment.url}/ticketsWithFile`;

  constructor(private http: HttpClient, private configService: ConfigurationService) { }

  readTicketsByInvoiceCode(invoiceCode: string, type: Array<string> = []): Observable<ResponseModel<Paging<Ticket[]>>> {
    let params = new HttpParams();
    params = params.set("invoiceCode", invoiceCode);
    params = type.length > 0 ? params.appendAll({ "type": type }) : params;

    return this.http.get<ResponseModel<Paging<Ticket[]>>>(`${this.url}`, { params });
  }

  readTickets(filter: Filter<TicketFilter>) {
    let params = new HttpParams();
    params = params
      .set("page", filter.page.toString())
      .set("pageSize", filter.pageSize.toString());

    params = filter.value.number ? params.append("number", filter.value.number) : params;
    params = filter.value.customerCode ? params.append("customerCode", filter.value.customerCode) : params;
    params = filter.value.startDate ? params.append("startDate", filter.value.startDate) : params;
    params = filter.value.endDate ? params.append("endDate", filter.value.endDate) : params;
    params = filter.value.invoiceCode ? params.append("invoiceCode", filter.value.invoiceCode) : params;
    params = filter.value.processingStatus ? params.append("processingStatus", filter.value.processingStatus) : params;
    params = filter.value.text ? params.append("text", filter.value.text) : params;
    params = filter.value.type ? params.append("type", filter.value.type) : params;
    return this.http.get<ResponseModel<Paging<Array<Ticket>>>>(this.url, { params });
  }

  createTicket(
    customerCode: string,
    description: string,
    equipmentId: string,
    serial: string,
    invoiceCode: string,
    type: string,
    files: TicketFile[],
    branchCode: string,
    salesOrg: string,
    requiredInstalation?: boolean,
    destinationBranch?: string
  ): Observable<ResponseModel<Ticket>> {
    let params = new HttpParams();
    params = customerCode ? params.set("customerCode", customerCode) : params;
    params = description ? params.set("description", description) : params;
    params = equipmentId ? params.set("equipmentId", equipmentId) : params;
    params = serial ? params.set("serial", serial) : params;
    params = invoiceCode ? params.set("invoiceCode", invoiceCode) : params;
    params = type ? params.set("type", type) : params;
    params = branchCode ? params.set("branchCode", branchCode) : params;
    params = salesOrg ? params.set("salesOrg", salesOrg) : params;
    params = requiredInstalation != undefined ? params.set("reqInstallation", requiredInstalation ? "true" : "false") : params;
    params = destinationBranch ? params.set("destinationBranch", destinationBranch) : params;
    const formData = new FormData();
    const finalFiles = files.filter(f => !!f.file);
    for (let i = 0; i < finalFiles.length; i++) {
      const f = finalFiles[i];
      params = params.set(`file${i ? i + 1 : ''}Type`, f.type || '');
      formData.append(`file${i ? i + 1 : ''}`, f.file, f.file.name);
    }

    return this.http.post<ResponseModel<Ticket>>(`${this.urlWithFiles}`, formData, { params });
  }

  readTicket(code: any) {
    return this.http.get<ResponseModel<Ticket>>(`${this.url}/${code}`);
  }

  readTicketExternal(code: any) {
    return this.http.get<ResponseModel<TicketExternalFindResponse>>(`${this.url}/${code}/external`);
  }

  updateTicketToExternal(number: string, value: TicketExternalUpdateRequest) {
    return this.http.put<ResponseModel<boolean>>(`${this.url}/${number}/updateStatus/external`, value)
  }
}
